import React, { useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import JobList from "./components/List"
import Actions from "./components/Actions"
import { CompanyPage } from "../../components/common"
import { tabChangeRequest } from "../../reducers/company/tabChange.reducer"
import {
  createUpdateJobReset,
  getJobRequest,
  jobAddFilter,
  jobDetailReset,
} from "../../reducers/job/jobs.reducer"
import appRoutes from "../../routes/app.routes"
import { isUndefined } from "lodash"
import { rootReducersState } from "../../reducers"

const _ = { isUndefined }

const Jobs = (props) => {
  const [open, setOpen] = useState(false)
  const [page, setPage] = useState(1)
  /** When editing, Form uses PATCH immediately even if Redux detail has not loaded yet */
  const [editingJobId, setEditingJobId] = useState<number | string | undefined>(
    undefined
  )
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const {
    companyProfile: {
      data: { slug },
    },
  } = useSelector(({ company }: any) => company)
  const sessionReducer = useSelector(
    ({ session }: rootReducersState) => session
  )
  const {
    jobs: { jobFilter },
  } = useSelector(({ job }: any) => job)

  const companySlug = sessionReducer.currentCompany.slug

  const handleTabClick = (type: string) => {
    dispatch(jobAddFilter({ ...jobFilter, page: 1, q: "" }))
    dispatch(tabChangeRequest({ tab: "jobs", innerTab: type }))
    if (type === "Active") {
      navigate(appRoutes.companyActiveJobs.generatePath(companySlug))
    } else if (type === "Archive") {
      navigate(appRoutes.companyJobsArchive.generatePath(companySlug))
    } else if (type === "Drafts") {
      navigate(appRoutes.companyJobsDrafts.generatePath(companySlug))
    } else {
      navigate(appRoutes.companyJobs.generatePath(companySlug))
    }
  }

  const handleClose = () => {
    dispatch(jobDetailReset())
    dispatch(createUpdateJobReset())
    setEditingJobId(undefined)
    setOpen(false)
  }

  const handleOpen = (_id = undefined) => {
    if (_.isUndefined(_id)) {
      setEditingJobId(undefined)
    } else {
      setEditingJobId(_id)
      dispatch(getJobRequest({ id: _id }))
    }
    setOpen(true)
  }

  const handleSearch = (text: any) => {
    dispatch(jobAddFilter({ ...jobFilter, page: page, q: text.trim() }))
  }

  const setProfilePreview = () => {
    if (!_.isUndefined(slug)) {
      const win = window.open(
        appRoutes.companyPublicPageJobs.generatePath(slug),
        "_blank"
      )
      win.focus()
    }
  }

  const handleButtonClick = (type: string, text: any) => {
    switch (type) {
      case "Add":
        handleOpen(undefined)
        break
      case "Active":
      case "Archive":
      case "Drafts":
      case "All":
        handleTabClick(type)
        break
      case "Search":
        handleSearch(text)
        break
      case "Preview":
        setProfilePreview()
        break
      default:
        break
    }
  }

  return (
    <CompanyPage
      padded={false}
      header={<Actions handleClick={handleButtonClick} {...props} />}
    >
      <JobList
        open={open}
        page={page}
        setPage={setPage}
        editingJobId={editingJobId}
        handleOpen={handleOpen}
        handleClose={handleClose}
        {...props}
      />
    </CompanyPage>
  )
}
export default Jobs
